<template>
  <tr :class="['clickable', { 'error-tr': entity.result === 'error' }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Začátek' | translate" class="first_data">{{ getStart }}</td>
    <td :data-th="'Konec' | translate">{{ getEnd }}</td>
    <td :data-th="'Status' | translate">{{ entity.status }}</td>
    <td :data-th="'Výsledek' | translate">
      <img :class="['is_set']" src="../../../assets/images/is-set.svg" :alt="'Ano' | translate"
           v-if="entity.result === 'ok'">
      <img :class="['is_set']" src="../../../assets/images/isnot-set.svg" :alt="'Ne' | translate"
           v-else-if="entity.result === 'error'">
    </td>
    <td class="no_padding"></td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

	export default {
		name: "CronRunRow",
        props: {
			entity: Object,
        },
    mixins: [rowActions],
		computed: {
			getStart() {
				if (this.entity.start_timestamp) {
					return this.$_datetime_format(this.entity.start_timestamp)
				} else {
					return this.entity.start
				}
			},
			getEnd() {
				if (this.entity.end_timestamp) {
					return this.$_datetime_format(this.entity.end_timestamp)
				} else {
					return this.entity.end
				}
			}
		},
		methods: {
			goToDetail(e, id) {
				this.$router.push({name: 'cronRunLog', params: {id: id}})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/crons/CronRunRow.vue